import { render, staticRenderFns } from "./InstitucionalSliderTemasGlidePt.vue?vue&type=template&id=2a45537b&"
import script from "./InstitucionalSliderTemasGlidePt.vue?vue&type=script&lang=js&"
export * from "./InstitucionalSliderTemasGlidePt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports